<template>
  <header class="site_header">
    <div
      class="header index"
    >
      <div class="outer-width">
        <nav
          class="navbar navbar-expand-md navbar-light navbar-default"
          role="navigation"
        >
          <div class="navbar-collapse collapse">
            <router-link
              to="/home"
              class="navbar-brand"
            >
              <div class="pull-left logo_block mobile_hide">
                <img src="/images/logo.png">
              </div>
              <div class="pull-left logo_block d-sm-none d-block" />
            </router-link>
            <ul class="navbar-nav mx-auto">
              <li class="nav-item">
                <router-link to="/news">
                  最新消息
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/job-opening/zh">
                  職缺搜尋
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/off-campus-internship">
                  校外實習
                </router-link>
              </li>
              <li class="nav-item">
              </li>
              <li
                class="nav-item"
                @mouseover="lecturesBool = true"
                @mouseleave="lecturesBool = false"
              >
                <a class="">
                  學生報名
                </a>
                <div class="dropdown">
                  <div
                    class="dropdown-menu"
                    :style="'background-color: rgb(46, 64, 104);opacity: 0.8; display:' + lecturesDropdown(lecturesBool)"
                  >
                    <router-link
                      to="/career-counselling/career-counselors"
                      style="width: 100%"
                    >
                      職涯諮詢
                    </router-link>
                    <router-link
                      to="/career-counselling/industry-mentors"
                      style="width: 100%"
                    >
                      業師諮詢
                    </router-link>
                    <router-link
                      to="/lectures/lecture"
                      style="width: 100%"
                    >
                      職涯講座
                    </router-link>
                    <router-link
                      to="/lectures/workshop"
                      style="width: 100%"
                    >
                      工作坊
                    </router-link>
                    <router-link
                      to="/lectures/recruitment"
                      style="width: 100%"
                    >
                      徵才說明會
                    </router-link>
                    <router-link
                      to="/lectures/internship"
                      style="width: 100%"
                    >
                      實習說明會
                    </router-link>
                    <router-link
                      to="/enterprise-visits"
                      style="width: 100%"
                    >
                      企業參訪
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="nav-item">
                <router-link to="/campus-recruiting">
                  企業報名
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/job-opening/en">
                  Job Opening
                </router-link>
              </li>
              <li class="nav-item">
                    <a :href="`https://ucan.moe.edu.tw`" target="_blank">UCAN</a>
                </li>
              <li class="nav-item">
                <router-link to="/faq">
                  FAQ
                </router-link>
              </li>     
            </ul>
            <ul class="navbar-right login_list text-nowrap">
              <li class="login_item" v-if="!isAuthenticatedGetter || isStudentGetter">
                <router-link to="/students">
                  <circle-icon-button
                    title="學生專區"
                    is-vertical
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_student.svg">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="!isAuthenticatedGetter || isEnterpriseGetter">
                <router-link to="/enterprises">
                  <circle-icon-button
                    title="企業專區"
                    is-vertical
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_enterprise.svg">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="!isAuthenticatedGetter || isTeacherGetter">
                <router-link to="/teachers">
                  <circle-icon-button
                    title="實習業務"
                    is-vertical
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_teacher.png">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="isAuthenticatedGetter">
                <circle-icon-button
                  title="登出"
                  is-vertical
                  color="white"
                  @click="letMeLogout()"
                >
                  <img src="/images/icon_logout.svg">
                </circle-icon-button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="mobile_header">
      <div class="inner-width">
        <button class="mobile_menu_btn no-btn-style">
          <font-awesome-icon icon="bars" />
        </button>
        <div class="mobile_logo">
          <router-link
            to="/home"
            class="navbar-brand"
          >
            <img src="/images/mobile_logo.png">
          </router-link>
        </div>
      </div>
      <div class="mobile_menu_area">
        <div id="mobile-menu-modal">
          <div
            id="js-mobile-header-close"
            class="button-close js-mobile-header-close"
          />
          <div class="mobile_logo mt-3">
            <img src="/images/mobile_logo.png">
          </div>
          <div class="mobile_menu_block"
               style="
               overflow-y: scroll;
               height: 80%;"
          >
            <ul class="navbar-right login_list">
              <li class="login_item" v-if="!isAuthenticatedGetter || isStudentGetter">
                <router-link to="/students">
                  <circle-icon-button
                    title="學生專區"
                    is-vertical
                    class="js-mobile-header-close"
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_student.svg">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="!isAuthenticatedGetter || isEnterpriseGetter">
                <router-link to="/enterprises">
                  <circle-icon-button
                    title="企業專區"
                    is-vertical
                    class="js-mobile-header-close"
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_enterprise.svg">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="!isAuthenticatedGetter || isTeacherGetter">
                <router-link to="/teachers">
                  <circle-icon-button
                    title="實習業務"
                    is-vertical
                    class="js-mobile-header-close"
                    @click="getPreviousUrl()"
                  >
                    <img src="/images/icon_teacher.png">
                  </circle-icon-button>
                </router-link>
              </li>
              <li class="login_item" v-if="isAuthenticatedGetter">
                <circle-icon-button
                  title="登出"
                  is-vertical
                  color="white"
                  class="js-mobile-header-close"
                  @click="letMeLogout()"
                >
                  <img src="/images/icon_logout.svg">
                </circle-icon-button>
              </li>
            </ul>
            <ul class="mobile_menu_list">
              <li class="mobile_menu_item">
                <router-link
                  to="/news"
                  class="js-mobile-header-close"
                >
                  最新消息
                </router-link>
              </li>
              <li class="mobile_menu_item">
                <router-link
                  to="/job-opening/zh"
                  class="js-mobile-header-close"
                >
                  職缺搜尋
                </router-link>
              </li>
              <li class="mobile_menu_item">
                <router-link
                  to="/off-campus-internship"
                  class="js-mobile-header-close"
                >
                  校外實習
                </router-link>
              </li>
              <li
                class="mobile_menu_item"
                @click="lecturesBool = !lecturesBool"
              >
                <a class="">
                  學生報名
                </a>
                <router-link
                  to="/career-counselling/career-counselors"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  職涯諮詢
                </router-link>
                <router-link
                  to="/career-counselling/industry-mentors"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  業師諮詢
                </router-link>
                <router-link
                  to="/lectures/lecture"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  職涯講座
                </router-link>
                <router-link
                  to="/lectures/workshop"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  工作坊
                </router-link>
                <router-link
                  to="/lectures/recruitment"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  徵才說明會
                </router-link>
                <router-link
                  to="/lectures/internship"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  實習說明會
                </router-link>
                <router-link
                  to="/enterprise-visits"
                  class="js-mobile-header-close"
                  :style="'background-color: rgb(46, 64, 104); display:' + lecturesDropdown(lecturesBool)"
                  style="width: 100%"
                >
                  企業參訪
                </router-link>
              </li>
              <li class="mobile_menu_item">
                <router-link
                  to="/campus-recruiting"
                  class="js-mobile-header-close"
                >
                  廠商報名
                </router-link>
              </li>
              <li class="mobile_menu_item">
                <router-link
                  to="/job-opening/en"
                  class="js-mobile-header-close"
                >
                  Job Opening
                </router-link>
              </li>
              <li class="mobile_menu_item">
                    <a :href="`https://ucan.moe.edu.tw`" target="_blank">UCAN</a>
                </li>
              <li class="mobile_menu_item">
                <router-link
                  to="/faq"
                  class="js-mobile-header-close"
                >
                  FAQ
                </router-link>
              </li>
              <!--
                <li class="mobile_menu_item">
                    <a :href="`${ucanGetter.ucan_link}`" target="_blank">UCAN</a>
                </li>
                -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <slot />
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import CircleIconButton from '~components/common/buttons/CircleIcon'
export default {
  name: 'Header',
  components: {
    CircleIconButton
  },
  data: function () {
    return {
      lecturesBool: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAuthenticatedGetter',
      'isStudentGetter',
      'isEnterpriseGetter',
      'isTeacherGetter',
    ])
    // ...mapGetters('pages/ucan', [
    //   'ucanGetter'
    // ])
  },
  // async created () {
  //   await this.getUCANUrl()
  // },
  methods: {
    ...mapActions('auth', [
      'userLogout'
    ]),
    // ...mapActions('pages/ucan', [
    //   'getUCANUrl'
    // ]),
    letMeLogout (type) {
      if(!type && this.isStudentGetter) type = 'student';
      if(!type && this.isEnterpriseGetter) type = 'enterprise';
      if(!type && this.isTeacherGetter) type = 'teacher';
      this.userLogout(type)
    },
    getPreviousUrl () {
      checkList = ["Home", "LoginEnterprise", "LoginStudent", "LoginTeacher"]

      if(!this.isAuthenticatedGetter ){
        if(!checkListList.contains(this.$router.history.current.name)){
          sessionStorage.setItem('previousRouteName',this.$router.history.current.name);
          sessionStorage.setItem('previousRouteQuery',JSON.stringify(this.$router.history.current.params));
        }


      }

  

    },
    lecturesDropdown (isShow) {
      return isShow ? 'block' : 'none'
    }
  }

}
</script>
